export default __webpack_public_path__ + "static/media/homebanner-a8f289d605f57438370bfc50c02a3785.png";